const getShopifyThemeColors = () => {
  const styles = getComputedStyle(document.documentElement);
  const buttonColorRgba = styles.getPropertyValue('--color-button');
  
  if (buttonColorRgba) {
    const rgbaMatch = buttonColorRgba.match(/(\d+),\s*(\d+),\s*(\d+)/);
    if (rgbaMatch) {
      return [ 
        parseInt(rgbaMatch[1]),
        parseInt(rgbaMatch[2]), 
        parseInt(rgbaMatch[3])
      ];
    }
  }
  
  const buttonColor = styles.getPropertyValue('--button-background') ||
                     styles.getPropertyValue('--solid-button-background') ||
                     '#2980b9';
  
  const hexColor = buttonColor.trim().replace('#', '');
  if (hexColor.length === 6) {
    return [
      parseInt(hexColor.substr(0, 2), 16),
      parseInt(hexColor.substr(2, 2), 16),
      parseInt(hexColor.substr(4, 2), 16)
    ];
  }
  
  return [41, 128, 185];
};

const getShopLogo = () => {
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings && window.Shopify.theme.settings.logo) {
    console.log('Logo desde Shopify.theme.settings:', window.Shopify.theme.settings.logo);
    return window.Shopify.theme.settings.logo;
  }

  const logoImg = document.querySelector('.header__heading-logo');
  if (logoImg && logoImg.src) {
    console.log('Logo encontrado con .header__heading-logo:', logoImg.src);
    return logoImg.src;
  }

  const logoSelectors = [
    '.header__logo-image',
    '.header__logo img',
    '.site-header__logo img', 
    '.logo img',
    '.header-logo img',
    '.site-logo img',
    '.brand img',
    '.header__brand img',
    '.navbar-brand img',
    'img[alt*="logo" i]',
    'img[alt*="Logo"]',
    'img[class*="logo" i]',
    'img[id*="logo" i]',
    '.header img[src*="logo" i]',
    'header img',
    '.site-header img:first-child'
  ];

  for (const selector of logoSelectors) {
    const logoImg = document.querySelector(selector);
    if (logoImg && logoImg.src) {
      console.log('Logo encontrado con selector:', selector, 'URL:', logoImg.src);
      return logoImg.src;
    }
  }
  
  console.log('No se encontró logo, selectores probados:', logoSelectors);
  return null;
};

const loadImageAsBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      } catch (error) {
        reject(error);
      }
    };
    
    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = url;
  });
};

const generatePDFBuffer = async (cartData, draftOrder, customerName) => {
  try {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();
    
    const primaryColor = getShopifyThemeColors();
    const textColor = [0, 0, 0];
    const lightGray = [236, 240, 241];
    const darkGray = [128, 128, 128];
    
    let yPosition = 20;
    
    // Header con fondo blanco
    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, 210, 40, 'F');
    
    // Línea separadora
    doc.setFillColor(...primaryColor);
    doc.rect(0, 35, 210, 3, 'F');
    
    doc.setTextColor(...textColor);
    
    const logoUrl = getShopLogo();
    let logoAdded = false;
    
    console.log('Intentando cargar logo:', logoUrl);
    
    if (logoUrl) {
      try {
        const logoBase64 = await loadImageAsBase64(logoUrl);
        doc.addImage(logoBase64, 'PNG', 20, 15, 35, 14);
        logoAdded = true;
        console.log('Logo agregado exitosamente al PDF');
      } catch (error) {
        console.error('Error cargando logo:', error);
      }
    }
    
    // Título
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    const titleText = 'Cotización de Productos';
    const titleWidth = doc.getTextWidth(titleText);
    const titleX = (210 - titleWidth) / 2;
    doc.text(titleText, titleX, 25);
    
    if (!logoAdded) {
      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      const shopName = window.Shopify.shop || 'TIENDA';
      const shopWidth = doc.getTextWidth(shopName);
      const shopX = (210 - shopWidth) / 2;
      doc.text(shopName, shopX, 30);
    }
    
    yPosition = 50;
    
    // Información de cotización
    doc.setTextColor(...textColor);
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text('INFORMACIÓN DE COTIZACIÓN', 20, yPosition);
    
    yPosition += 10;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    
    const quoteInfo = [
      ['Número de Cotización:', draftOrder.name || `#${draftOrder.id}`],
      ['Fecha:', new Date().toLocaleDateString('es-CL')],
      ['Cliente:', customerName],
      ['Email:', draftOrder.email || '']
    ];
    
    quoteInfo.forEach(([label, value]) => {
      doc.setFont("helvetica", "bold");
      doc.text(label, 20, yPosition);
      doc.setFont("helvetica", "normal");
      doc.text(value, 70, yPosition);
      yPosition += 6;
    });
    
    yPosition += 10;
    
    // Título de productos
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text('PRODUCTOS COTIZADOS', 20, yPosition);
    
    yPosition += 10;
    
    // Headers de tabla
    doc.setFillColor(...lightGray);
    doc.rect(20, yPosition - 5, 170, 8, 'F');
    
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    
    const headers = ['Producto', 'SKU', 'Cant.', 'Precio Unit.', 'Total'];
    const headerPositions = [25, 100, 130, 145, 170];
    
    headers.forEach((header, index) => {
      doc.text(header, headerPositions[index], yPosition);
    });
    
    yPosition += 10;
    
    // Items de productos
    doc.setFont("helvetica", "normal");
    
    cartData.items.forEach((item, index) => {
      // Usar line_price que ya viene calculado del backend con descuentos aplicados
      const itemTotal = item.line_price / 100;
      
      if (index % 2 === 0) {
        doc.setFillColor(250, 250, 250);
        doc.rect(20, yPosition - 4, 170, 7, 'F');
      }
      
      const productTitle = item.product_title.length > 25 ? 
        item.product_title.substring(0, 25) + '...' : 
        item.product_title;
      
      const variant = item.variant_title ? 
        (item.variant_title.length > 15 ? item.variant_title.substring(0, 15) + '...' : item.variant_title) : 
        '';
      
      // Nombre del producto
      doc.setTextColor(...textColor);
      doc.text(productTitle, 25, yPosition);
      
      if (variant) {
        doc.setFontSize(8);
        doc.setTextColor(...darkGray);
        doc.text(variant, 25, yPosition + 3);
        doc.setFontSize(9);
        doc.setTextColor(...textColor);
      }
      
      // SKU, Cantidad, Precio unitario y Total
      doc.text(item.sku || 'N/A', 100, yPosition);
      doc.text(item.quantity.toString(), 135, yPosition);
      doc.text(`${(item.price / 100).toLocaleString('es-CL')}`, 145, yPosition);
      doc.text(`${itemTotal.toLocaleString('es-CL')}`, 170, yPosition);
      
      yPosition += variant ? 10 : 7;
      
      if (yPosition > 250) {
        doc.addPage();
        yPosition = 20;
      }
    });
    
    // Total
    yPosition += 5;
    doc.setLineWidth(0.5);
    doc.line(20, yPosition, 190, yPosition);
    yPosition += 10;
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    
    const currency = cartData.currency || 'CLP';
    const totalFormatted = (cartData.total_price / 100).toLocaleString('es-CL');
    
    doc.text('TOTAL:', 140, yPosition);
    doc.text(`${totalFormatted} ${currency}`, 170, yPosition);
    
    yPosition += 8;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Total de productos: ${cartData.item_count}`, 140, yPosition);
    
    if (cartData.note) {
      yPosition += 15;
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.text('NOTAS:', 20, yPosition);
      
      yPosition += 8;
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      
      const noteLines = doc.splitTextToSize(cartData.note, 170);
      noteLines.forEach(line => {
        doc.text(line, 20, yPosition);
        yPosition += 5;
      });
    }
    
    yPosition += 20;
    
    doc.setFillColor(248, 249, 250);
    doc.rect(20, yPosition - 5, 170, 30, 'F');
    
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(...textColor);
    doc.text('NOTA COMERCIAL', 20, yPosition + 2);
    
    yPosition += 8;
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(...darkGray);
    
    const commercialNotes = [
      '1.- Cotización valida por 15 días, no constituye venta, solo para valorización.',
      '2.- Disponibilidad de producto sujeta a confirmación de STOCK.',
      '3.- Descuento de acuerdo a forma de pago y volumen.',
      '4.- Favor confirmar pago y adjuntar comprobante al correo electrónico.'
    ];
    
    commercialNotes.forEach(note => {
      const noteLines = doc.splitTextToSize(note, 165);
      noteLines.forEach(line => {
        doc.text(line, 22, yPosition);
        yPosition += 4;
      });
    });
    
    // Footer
    const pageCount = doc.internal.getNumberOfPages();
    const shopName = window.Shopify.shop || 'Tienda';
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(...darkGray);
      doc.text(`Página ${i} de ${pageCount}`, 20, 290);
      doc.text(`${shopName} - Cotización generada automáticamente`, 20, 285);
      doc.text(new Date().toLocaleString('es-CL'), 160, 290);
    }
    
    const pdfBase64 = doc.output('datauristring').split(',')[1];
    return pdfBase64;
    
  } catch (error) {
    console.error('Error generando PDF:', error);
    return generateFallbackPDF(cartData, draftOrder, customerName);
  }
};

const generateFallbackPDF = (cartData, draftOrder, customerName) => {
  try {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();
    
    const shopName = window.Shopify.shop || 'Tienda';
    
    doc.setFontSize(20);
    doc.text(`${shopName} - Cotización`, 20, 30);
    
    doc.setFontSize(12);
    doc.text(`Número: ${draftOrder.name || draftOrder.id}`, 20, 50);
    doc.text(`Cliente: ${customerName}`, 20, 60);
    doc.text(`Fecha: ${new Date().toLocaleDateString('es-CL')}`, 20, 70);
    doc.text(`Total: ${(cartData.total_price / 100).toLocaleString('es-CL')} ${cartData.currency || 'CLP'}`, 20, 80);
    doc.text(`Productos: ${cartData.item_count} items`, 20, 90);
    
    let yPos = 110;
    doc.text('Productos:', 20, yPos);
    yPos += 10;
    
    cartData.items.forEach((item, index) => {
      if (yPos > 250) {
        doc.addPage();
        yPos = 20;
      }
      doc.text(`${index + 1}. ${item.product_title} - Cantidad: ${item.quantity}`, 20, yPos);
      yPos += 8;
    });
    
    return doc.output('datauristring').split(',')[1];
  } catch (error) {
    console.error('Error en PDF fallback:', error);
    throw new Error('No se pudo generar el PDF');
  }
};

const preparePDFData = async (cartData, draftOrder, customerEmail) => {
  const customerName = window.shopifyCustomer?.firstName && window.shopifyCustomer?.lastName 
    ? `${window.shopifyCustomer.firstName} ${window.shopifyCustomer.lastName}`
    : 'Cliente';

  return {
    customerEmail: customerEmail,
    customerName: customerName,
    subject: `Tu cotización ${draftOrder.name || '#' + draftOrder.id} está lista - ${window.Shopify.shop}`,
    orderNumber: draftOrder.name || draftOrder.id,
    pdfBuffer: await generatePDFBuffer(cartData, draftOrder, customerName),
    customMessage: `Hola ${customerName}, adjuntamos tu cotización solicitada.`
  };
};

const sendPDFQuote = async (cartData, draftOrder, customerEmail) => {
  console.log('Datos del carrito recibidos para PDF:', cartData);
  console.log('¿Tiene descuentos wholesale?', cartData.items?.some(item => item.has_discount));
  
  const pdfData = await preparePDFData(cartData, draftOrder, customerEmail);
  
  if (typeof window.sendPDFToAPI === 'function') {
    return await window.sendPDFToAPI(pdfData);
  } else {
    throw new Error('sendPDF.js no está cargado');
  }
};

window.PDFFrontGenerator = {
  generatePDFBuffer,
  generateFallbackPDF,
  preparePDFData,
  sendPDFQuote,
  getShopifyThemeColors,
  getShopLogo,
  loadImageAsBase64
};